import { useQuery as useReactQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import axios from 'axios';

type Error = {
  code: number;
  data: string;
  message: string;
  status: string;
};

type QueryProps<R, P> = {
  params?: P;
} & Omit<UseQueryOptions<R, Error, R, [string, P]>, 'queryKey' | 'queryFn'>;

export type ExecuteUseQuery<R, P = void> = (props?: QueryProps<R, P>) => UseQueryResult<R, Error>;

export const useQuery = <R, P = void>(
  url: string,
  props?: QueryProps<R, P>
): UseQueryResult<R, Error> =>
  useReactQuery({
    queryKey: [url, { ...props?.params } as any],
    queryFn: ({ queryKey }) => {
      const [, params] = queryKey;
      return axios
        .get(url, {
          params
        })
        .then((res: any) => {
          if (res?.data) {
            return res.data;
          }
          throw {
            code: res?.data?.code || 500,
            data: res?.data?.data || 'Bad request',
            message: res?.data?.message || 'Bad request',
            status: res?.data?.status || 'error'
          };
        })
        .catch(e => {
          throw {
            code: e?.status || 500,
            data: 'Bad request',
            message: e?.message || 'Bad request'
          };
        });
    },
    retry: false,
    ...props
  });
